'use client';

import React, { useState } from 'react';
import { Field, ErrorMessage } from 'formik';
import { stages } from '../../../constants/formFields/stages';

export const StepFive = () => {
  // ================================ UseState Declarations ============================== //
  const [isOpen, setIsOpen] = useState(false);
  // ===================================================================================== //
  return (
    <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step">
      {/* <h6 className="text-lg font-bold mb-6">Case Details</h6> */}

      <div className="mb-6  form-radio2-main">
        <label className="block text-gray-700 font-medium mb-2">
          Case Stage{' '}
          <span
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            <svg
              fill="#454545"
              width="14"
              height="14"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                {' '}
                <g>
                  {' '}
                  <path d="M12.83,4.86a5,5,0,0,0-3-.86,4.15,4.15,0,0,0-2.29.6h0A3.62,3.62,0,0,0,6,7.63H8.07a2.57,2.57,0,0,1,.41-1.24A1.61,1.61,0,0,1,10,5.7a1.66,1.66,0,0,1,1.44.57,2,2,0,0,1,.39,1.21,1.8,1.8,0,0,1-.36,1.08,2.18,2.18,0,0,1-.5.51l-.59.46a3.28,3.28,0,0,0-1.05,1.16A5.94,5.94,0,0,0,9,12.39H11a3.47,3.47,0,0,1,.11-.86,1.89,1.89,0,0,1,.68-.93l.57-.45a6,6,0,0,0,1.16-1.09A2.8,2.8,0,0,0,14,7.35,2.85,2.85,0,0,0,12.83,4.86ZM9,15.88h2.16V13.8H9ZM10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,18.2A8.2,8.2,0,1,1,18.2,10,8.21,8.21,0,0,1,10,18.2Z"></path>{' '}
                </g>{' '}
              </g>
            </svg>
          </span>{' '}
        </label>
        {isOpen && (
          <div className="clickable-content-small">
            <p>
              {' '}
              <b> Grievance:</b> A formal complaint raised by an employee within the company
              regarding workplace issues.
            </p>
            <p>
              <b>Negotiations: </b> Discussions between the employee and employer to resolve
              workplace issues or reach a settlement.{' '}
            </p>
            <p>
              <b>ACAS: </b> Involves the Advisory, Conciliation and Arbitration Service, which helps
              to resolve disputes between employees and employers.
            </p>
            <p>
              <b>Tribunal: </b> A legal process where an employment tribunal makes a decision on a
              dispute between an employee and employer.{' '}
            </p>
          </div>
        )}
        <div className="space-y-2">
          {stages.map((ele, i) => {
            const id = `stages_${i}`;
            return (
              <div className="flex items-center form-radio2" key={i}>
                <Field
                  type="radio"
                  id={id}
                  name="stages"
                  value={ele.value}
                  className="mr-2"
                />
                <label htmlFor={id}>{ele.label}</label>
              </div>
            )
          })}
          <ErrorMessage name="stages" component="div" className="required-text" />
        </div>
      </div>
    </div>
  );
};
